export default __webpack_public_path__ + "static/media/61t.2ea91218.jpg";